const env = process.env.NEXT_PUBLIC_APP_ENV;

const isLocal = typeof document !== 'undefined' && document.location.hostname === 'localhost';

const serviceEndpoint = isLocal ? env || 'http://localhost:8080/vegdim/api' : '/vegdim/api';

const endpointUrls = {
	weatherStation: '/v0/vegdim/v%C3%A6rstasjon/liste',
	validWeatherStation: '/v0/vegdim/v%C3%A6rstasjon/gyldige',
	weatherStationForId: '/v0/vegdim/v%C3%A6rstasjon/id',
	backofficeWeatherStation: '/v0/vegdim/backoffice/værstasjon',
	backofficeWeatherStationGetTable: '/v0/vegdim/backoffice/tablejson',
	backofficeWeatherStationGetReadyTable: '/v0/vegdim/backoffice/readytablejson',
	backofficeWeatherStationUpdateWeatherStations: '/v0/vegdim/backoffice/updateWeatherstations',
	backofficeWeatherStationUpdate: '/v0/vegdim/backoffice/button',
	getTelehivBeregning: '/v0/vegdim/fhm',
	getMaterials: '/v0/vegdim/materials',
	getMaterialsWithAllProperties: '/v0/vegdim/materials/getwithallproperties',
	getUnleashToggles: '/v0/vegdim/unleash/toggles',
	getDummyRutting: '/v0/vegdim/rutting/dummy',
	calculateRutting: '/v0/vegdim/rutting/calculate',
	calculatePiggdekkSlitasje: '/v0/vegdim/rutting/piggdekkslitasje',
	getDimensjoneringsklasser: '/v0/vegdim/rutting/dimensjoneringsklasser',
	cleanCache: '/v0/vegdim/backoffice/cleancache',
	clearCache: '/v0/vegdim/backoffice/clearcache',
};

type Method = 'GET' | 'POST';

export const getApiUrl = (endpoint: keyof typeof endpointUrls) => {
	return `${serviceEndpoint}${endpointUrls[endpoint]}`;
};

export const getFetchInit = (method: Method): RequestInit => ({
	method,
	mode: 'cors',
	headers: {
		'allow-origin': '*',
	},
});

function postFetchInit<T>(body: T): RequestInit {
	const bodyInit: BodyInit = JSON.stringify(body);
	return {
		method: 'POST',
		body: bodyInit,
		mode: 'cors',
		headers: {
			'content-type': 'application/json',
			'allow-origin': '*',
		},
	};
}

export type FetchResponseType<T> = { statusCode: number; data: T | undefined };

export async function performFetch<T>(params: {
	endpoint: keyof typeof endpointUrls;
	method: Method;
}): Promise<FetchResponseType<T>> {
	const response = await fetch(getApiUrl(params.endpoint), getFetchInit(params.method));
	return handleResponse<T>(response);
}

/**
 * Slik oppgis response- og requestTypene i funksjons kallet: <ResponseType, RequestType>
 * @param params
 */
export async function performFetchWithPayload<ResponseType, RequestType>(params: {
	endpoint: keyof typeof endpointUrls;
	payload: RequestType;
}): Promise<FetchResponseType<ResponseType>> {
	const response = await fetch(
		getApiUrl(params.endpoint),
		postFetchInit<RequestType>(params.payload)
	);
	return handleResponse<ResponseType>(response);
}

export async function updateById<T>(params: {
	id: number;
	endpoint: keyof typeof endpointUrls;
	method: Method;
}) {
	const apiUrl = getApiUrl(params.endpoint);
	const response = await fetch(`${apiUrl}/${params.id}`, getFetchInit(params.method));
	return handleResponse<T>(response);
}

async function handleResponse<T>(response: Response): Promise<FetchResponseType<T>> {
	let data: T | undefined = undefined;
	try {
		data = await response.json();
	} catch (e) {
		console.error('Kunne ikke parse data: ', e);
	}
	return { data, statusCode: response.status };
}
